import React from 'react';

interface YearSelectorProps {
  onChange: (year: string) => void;
}

const YearSelector: React.FC<YearSelectorProps> = ({ onChange }) => {
  const years = Array.from(new Array(20), (val, index) => (new Date().getFullYear() - index).toString());

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value);
  };

  return (
    <select onChange={handleSelectChange} title='year' className='year-selector'>
      {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </select>
  );
};

export default YearSelector;